import { HeartHandshake, ShieldCheck, Sparkles, UsersRound } from 'lucide-react';
import PublicSiteLayout from '../components/PublicSiteLayout';

const principles = [
  [ShieldCheck, 'Parent control first', 'Suggestions should remain visible and reviewable before they become part of a family plan.'],
  [Sparkles, 'Reduce interpretation work', 'The useful outcome is not another summary. It is a clearer understanding of what may need attention next.'],
  [UsersRound, 'Designed for real caregivers', 'Family coordination includes multiple adults, competing schedules, incomplete context, and changing responsibilities.'],
  [HeartHandshake, 'Calm over automation theater', 'Technology should reduce family stress without hiding consequential actions behind invisible automation.'],
];

function AboutPage() {
  return (
    <PublicSiteLayout
      eyebrow="About Little Adda"
      title="Less school-email archaeology. More calm family action."
      lede="Little Adda is being built around a simple observation: parents rarely need more information—they need help turning scattered information into a plan they still control."
    >
      <section className="mx-auto grid max-w-7xl gap-10 px-5 py-16 sm:px-8 lg:grid-cols-[0.85fr_1.15fr] lg:py-24">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.18em] text-teal-700">Why this exists</p>
          <h2 className="mt-4 text-3xl font-black leading-tight sm:text-4xl">Family logistics are hidden inside communication.</h2>
        </div>
        <div className="space-y-5 text-lg leading-9 text-slate-600">
          <p>School newsletters, teacher notes, activity updates, forms, and deadline reminders arrive across different channels and at inconvenient times. Each message asks a parent to interpret what matters, remember it, and coordinate the next step.</p>
          <p>Little Adda aims to make that work visible. It identifies likely actions and drafts useful reminders, tasks, and calendar suggestions. The parent remains responsible for approving what becomes part of the family plan.</p>
          <p>The product is intended to support parents and caregivers. It is not presented as a school, school district, or substitute for authoritative school communication.</p>
        </div>
      </section>

      <section className="border-y border-slate-200 bg-white py-16 sm:py-20">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <p className="text-xs font-black uppercase tracking-[0.18em] text-teal-700">Product principles</p>
          <div className="mt-6 grid gap-4 md:grid-cols-2">
            {principles.map(([Icon, title, copy]) => (
              <article key={title} className="rounded-[24px] border border-slate-200 bg-slate-50 p-6">
                <Icon className="h-7 w-7 text-teal-700" aria-hidden="true" />
                <h2 className="mt-5 text-xl font-black">{title}</h2>
                <p className="mt-3 leading-7 text-slate-600">{copy}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </PublicSiteLayout>
  );
}

export default AboutPage;
